import { Component, OnInit } from '@angular/core';
import { ClubModel } from '@bayclubs/employee-management-api';
import { InstructorModel } from '@bayclubs/group-classes-employee-api';

@Component({
    selector: 'app-instructor-substitution',
    templateUrl: './instructor-substitution.component.html',
    styleUrls: ['./instructor-substitution.component.scss'],
    standalone: false
})
export class InstructorSubstitutionComponent implements OnInit {
    close: Function;

    //input parameters
    public instructor: InstructorModel;
    public club: ClubModel;

    public selectedSubstituteInstructor: InstructorModel = null;

    constructor() {}

    ngOnInit() {}

    public onSubstitutionInstructorSelected(substituteInstructor: InstructorModel) {
        this.selectedSubstituteInstructor = substituteInstructor;
    }

    public get isInstructorSelected(): boolean {
        return this.selectedSubstituteInstructor != null;
    }

    public confirm(): void {}

    public cancel(): void {
        this.selectedSubstituteInstructor = null;
    }
}
